import React from 'react';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';
import BasicLayout from 'layout/Basic';
import { Divider, Col } from 'antd';
import styled from 'styled-components';
import { convertProps } from 'lib/parseAPIResponse';
import Newsletter from 'containers/Newsletter';
import { SkyscraperMobile, Wideboard } from 'components/Ads';
import Section from 'components/Section';
import HtmlDescription from 'components/HtmlDescription';
import { merriweather } from 'styles/GlobalStyle';
import LogoHeadingSection from 'components/LogoHeadingSection';

const PageTitle = styled.h1`
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 0px;

    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const RuleText = styled.div`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: left;
    padding: 10px;
    color: ${({ theme }) => theme.colors.brownishGrey};
    @media (max-width: 992px) {
        ol {
            padding-inline-start: 20px;
        }
    }
`;

const NameCol = styled(Col)`
    @media (max-width: 992px) {
        margin-top: 25px;
    }
`;

const StyledDivider = styled(Divider)`
    @media (min-width: 992px) {
        margin-top: 100px;
    }
`;

interface Props {
    content: {
        name: string;
        title: string;
        content: string;
    };
    latestIssue: Issue;
    specification: MagazineSpecification;
    ads: PageAds;
}
export const AboutPage = ({ content, ads }: Props): JSX.Element => {
    const { name } = getConfig().publicRuntimeConfig;
    const { skyscraper, wideboardBottom } = ads;
    return (
        <BasicLayout ads={ads}>
            <LogoHeadingSection />
            <Section>
                <NameCol lg={{ span: 17, offset: 7 }} xs={24}>
                    <PageTitle>{name}</PageTitle>
                </NameCol>
            </Section>
            <Col xs={24} md={12} lg={0}>
                <SkyscraperMobile id={skyscraper[0]} margin="25px auto 0 auto" />
            </Col>
            <Col xs={24} md={12} lg={0}>
                <SkyscraperMobile id={skyscraper[1]} margin="25px auto 0 auto" />
            </Col>
            <StyledDivider />
            <Section>
                <Col span={24}>
                    <RuleText>
                        <HtmlDescription>{content.content}</HtmlDescription>
                    </RuleText>
                </Col>
            </Section>
            <Section gutter={[16, 32]} justify="center">
                <Col span={24}>
                    <Divider />
                </Col>
                <Col xs={24} md={20}>
                    <Newsletter />
                </Col>
                <Col span={24}>
                    <Divider />
                </Col>
            </Section>
            <Wideboard id={wideboardBottom[0]} />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async () => {
    const { apiUrl } = getConfig().publicRuntimeConfig;
    return Promise.all([
        fetch(`${apiUrl}/public/api/static-content/regulamin`),
        fetch(`${apiUrl}/public/api/naszadsik?path=regulamin`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();
        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default AboutPage;
